import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const MatchFilterBar = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  matchCount = 0 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Matches' },
    { value: 'pending', label: 'Pending Results' },
    { value: 'completed', label: 'Completed' },
    { value: 'draft', label: 'Draft Results' }
  ];

  const formatOptions = [
    { value: 'all', label: 'All Formats' },
    { value: 'T20', label: 'T20' },
    { value: 'ODI', label: 'ODI' },
    { value: 'Test', label: 'Test' }
  ];

  const stageOptions = [
    { value: 'all', label: 'All Stages' },
    { value: 'group', label: 'Group Stage' },
    { value: 'knockout', label: 'Knockout Stage' },
    { value: 'semifinal', label: 'Semifinal' },
    { value: 'final', label: 'Final' }
  ];

  const hasActiveFilters = filters?.status !== 'all' || filters?.format !== 'all' || filters?.stage !== 'all';

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 flex-1">
          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />
          
          <Select
            label="Format"
            options={formatOptions}
            value={filters?.format}
            onChange={(value) => onFilterChange('format', value)}
          />
          
          <Select
            label="Stage"
            options={stageOptions}
            value={filters?.stage}
            onChange={(value) => onFilterChange('stage', value)}
          />
        </div>

        <div className="flex items-center gap-3">
          {hasActiveFilters && (
            <Button
              variant="outline"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear Filters
            </Button>
          )}
          
          <div className="px-4 py-2 bg-muted rounded-lg">
            <p className="text-sm font-medium text-foreground">
              {matchCount} Match{matchCount !== 1 ? 'es' : ''}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchFilterBar;